export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  DEFAULT_CURRENT_PAGE: 1,
  PAGE_SIZE_OPTIONS: ["10", "20", "50", "100"],
  TABLE_POSITION: ["bottomLeft"],
};

export const DATETIME_FORMAT = {
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm:ss",
  US_DATETIME: "MM/DD/YYYY hh:mm A",
  CANADA_DATETIME: "YYYY-MM-DD hh:mm A",
  DATE_TIME_WITHOUT_SECONDS: "YYYY-MM-DD HH:mm",
};
export const DEFAULT_CALL_AVG_DURATION_FILTER = "10";
export const CUSTOM = "custom";
export const THIS_MONTH = "THIS_MONTH";
export const LAST_30_DAYS = "LAST_30_DAYS";
// Fallback date filter used by every dashboard / report page when the location
// admin has not configured a REPORT_SETTINGS default. Change this in one place
// to update the default everywhere.
export const DEFAULT_TIME = THIS_MONTH;
export const TODAY = "TODAY";
export const DATE_FILTER_OPTIONS = [
  { label: "Today", value: "TODAY" },
  { label: "Yesterday", value: "YESTERDAY" },
  { label: "This Week", value: "THIS_WEEK" },
  { label: "Last Week", value: "LAST_WEEK" },
  { label: "Month to date", value: "THIS_MONTH" },
  { label: "Last Month", value: "LAST_MONTH" },
  { label: "Last 30 Days", value: "LAST_30_DAYS" },
  { label: "Custom Date", value: CUSTOM },
];

export const DEPARTMENT_TYPES = [
  { label: "Parts", value: "PARTS" },
  { label: "Service", value: "SERVICE" },
  { label: "Sales", value: "SALES" },
  { label: "Marketing", value: "MARKETING" },
  { label: "Finance", value: "FINANCE" },
  { label: "Unknown", value: "Unknown" },
];

export const CALL_DIRECTION_FILTER = [
  { text: "Inbound", value: "INBOUND" },
  { text: "Outbound", value: "OUTBOUND" },
];

export const CALLER_OUTCOME_FILTER = [
  { text: "Connected", value: "NORMAL" },
  { text: "Missed", value: "MISSED" },
  { text: "Left Dial Plan", value: "LEFT_DIAL_PLAN" },
  { text: "Voicemail", value: "VOICEMAIL" },
];

export const CALL_ANSWERED_FILTER = [
  { text: "Yes", value: "YES" },
  { text: "No", value: "NO" },
];

export const AVERAGE_CALL_DURATION_FILTER = [
  { text: "0:10s", value: "10" },
  { text: "0:20s", value: "20" },
  { text: "0:25s", value: "25" },
  { text: "0:30s", value: "30" },
  { text: "0:35s", value: "35" },
  { text: "0:45s", value: "45" },
  { text: "0:60s", value: "60" },
];
